import { ValidationProps } from 'ui';
import { ListType } from './constants';

export const ACTION = {
  REQUEST_METADATA: 'TEXT_CONFIGURATION_LIST:REQUEST_METADATA',
  RECEIVE_METADATA: 'TEXT_CONFIGURATION_LIST:RECEIVE_METADATA',
  FAIL_METADATA: 'TEXT_CONFIGURATION_LIST:FAIL_METADATA',

  CLEAR_LIST: 'TEXT_CONFIGURATION_LIST:CLEAR_LIST',

  REQUEST_LIST: 'TEXT_CONFIGURATION_LIST:REQUEST_TEXTS',
  RECEIVE_LIST: 'TEXT_CONFIGURATION_LIST:RECEIVE_TEXTS',
  FAIL_LIST: 'TEXT_CONFIGURATION_LIST:FAIL_TEXTS',

  MODIFY_ITEM: 'TEXT_CONFIGURATION_LIST:MODIFY_ITEM',

  CANCEL_CHANGES: 'TEXT_CONFIGURATION_LIST:CANCEL_CHANGES',

  REQUEST_SAVE_CHANGES: 'TEXT_CONFIGURATION_LIST:REQUEST_SAVE_CHANGES',
  RECEIVE_SAVE_CHANGES: 'TEXT_CONFIGURATION_LIST:RECEIVE_SAVE_CHANGES',
  FAIL_SAVE_CHANGES: 'TEXT_CONFIGURATION_LIST:FAIL_SAVE_CHANGES',

  VALIDATION_CHANGE: 'TEXT_CONFIGURATION_LIST:VALIDATION_CHANGE',

  REQUEST_EXPORT_EXCEL: 'TEXT_CONFIGURATION_LIST:REQUEST_EXPORT_EXCEL',
  RECEIVE_EXPORT_EXCEL: 'TEXT_CONFIGURATION_LIST:RECEIVE_EXPORT_EXCEL',
  FAIL_EXPORT_EXCEL: 'TEXT_CONFIGURATION_LIST:FAIL_EXPORT_EXCEL',

  OPEN_EXCEL_IMPORT: 'TEXT_CONFIGURATION_LIST:OPEN_EXCEL_IMPORT',
  CLOSE_EXCEL_IMPORT: 'TEXT_CONFIGURATION_LIST:CLOSE_EXCEL_IMPORT',

  REQUEST_IMPORT_EXCEL: 'TEXT_CONFIGURATION_LIST:REQUEST_IMPORT_EXCEL',
  RECEIVE_IMPORT_EXCEL: 'TEXT_CONFIGURATION_LIST:RECEIVE_IMPORT_EXCEL',
  FAIL_IMPORT_EXCEL: 'TEXT_CONFIGURATION_LIST:FAIL_IMPORT_EXCEL',

  CLEAR_IMPORT_VALIDATION_ERRORS: 'TEXT_CONFIGURATION_LIST:CLEAR_IMPORT_VALIDATION_ERRORS'
};

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public listType: ListType, public requestId: number) { }
}

export class RequestMetadata {
  public type: string = ACTION.REQUEST_METADATA;
  constructor(public listType: ListType) { }
}

export class ReceiveMetadata<METADATA> {
  public type: string = ACTION.RECEIVE_METADATA;
  constructor(public listType: ListType, public metadata: METADATA) { }
}

export class FailMetadata {
  public type: string = ACTION.FAIL_METADATA;
  constructor(public listType: ListType) { }
}

export class RequestList<SEARCH_MODEL> {
  public type: string = ACTION.REQUEST_LIST;
  constructor(public listType: ListType, public requestId: number, public model: SEARCH_MODEL, public clearResults: boolean) { }
}

export class ReceiveList<ITEM_DATA> {
  public type: string = ACTION.RECEIVE_LIST;
  constructor(public listType: ListType, public requestId: number, public list: ITEM_DATA[], public numberOfResults: number) { }
}

export class FailList {
  public type: string = ACTION.FAIL_LIST;
  constructor(public listType: ListType, public requestId: number, public errors: string[]) { }
}

export class ModifyItem<MODIFIED_DATA> {
  public type: string = ACTION.MODIFY_ITEM;
  constructor(public listType: ListType, public modifiedData: MODIFIED_DATA) { }
}

export class CancelChanges {
  public type: string = ACTION.CANCEL_CHANGES;
  constructor(public listType: ListType) { }
}

export class RequestSaveChanges {
  public type: string = ACTION.REQUEST_SAVE_CHANGES;
  constructor(public listType: ListType) { }
}

export class ReceiveSaveChanges {
  public type: string = ACTION.RECEIVE_SAVE_CHANGES;
  constructor(public listType: ListType) { }
}

export class FailSaveChanges {
  public type: string = ACTION.FAIL_SAVE_CHANGES;
  constructor(public listType: ListType) { }
}

export class ValidationChange {
  public type: string = ACTION.VALIDATION_CHANGE;

  constructor(public listType: ListType, public validation: { [key: string]: ValidationProps }) { }
}

export class RequestExportExcel {
  public type: string = ACTION.REQUEST_EXPORT_EXCEL;
  constructor(public listType: ListType) { }
}

export class ReceiveExportExcel {
  public type: string = ACTION.RECEIVE_EXPORT_EXCEL;
  constructor(public listType: ListType) { }
}

export class FailExportExcel {
  public type: string = ACTION.FAIL_EXPORT_EXCEL;
  constructor(public listType: ListType) { }
}

export class OpenExcelImport {
  public type: string = ACTION.OPEN_EXCEL_IMPORT;
  constructor(public listType: ListType) { }
}

export class CloseExcelImport {
  public type: string = ACTION.CLOSE_EXCEL_IMPORT;
  constructor(public listType: ListType) { }
}

export class RequestImportExcel {
  public type: string = ACTION.REQUEST_IMPORT_EXCEL;
  constructor(public listType: ListType) { }
}

export class ReceiveImportExcel {
  public type: string = ACTION.RECEIVE_IMPORT_EXCEL;
  constructor(public listType: ListType) { }
}

export class FailImportExcel<VALIDATION_ERROR> {
  public type: string = ACTION.FAIL_IMPORT_EXCEL;
  constructor(public listType: ListType, public importValidationErrors: VALIDATION_ERROR[]) {
  }
}

export class ClearImportValidationErrors {
  public type: string = ACTION.CLEAR_IMPORT_VALIDATION_ERRORS;
  constructor(public listType: ListType) { }
}
